import { getLimitDate } from "util/date";
import moment from "moment";

// Emitedd cedip initial filter
export const today = moment().toDate();
export const date365DaysBefore = getLimitDate(-365);
export const date365DaysAfter = getLimitDate(365);
export const date30DaysBefore = getLimitDate(-30);

// Received cedip initial filters
export const date7DaysBefore = getLimitDate(-7);
export const date7DaysAfter = getLimitDate(7);

const CEDIP_TRANSMISSION_ACCEPTED = "ACEPTADA";

// filter cedip Transmitted
export const filterCedipTransmitted = (receivedCedip) => {
    if (receivedCedip.transmisiones && receivedCedip.transmisiones.length > 0) {
        return receivedCedip.transmisiones.filter(
            (transmision) =>
                transmision.cuitBeneficiario === receivedCedip.tenedorDocumento &&
                transmision.estado === CEDIP_TRANSMISSION_ACCEPTED,
        );
    }
    return [];
};
export const isCedipTransmitted = (cedip) => filterCedipTransmitted(cedip)?.length > 0;
